// extracted by mini-css-extract-plugin
export default {"container":"Z0irPF8J4VIUyaWJaRuH","loginSpacer":"T1dUlMciATMaoEtWAGO3"};